import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8">

          {/* Brand */}
          <div className="flex flex-col gap-3">
            <img
              src="/LogoHeader4.png"
              alt="Arabicroots"
              className="h-8 w-auto object-contain object-left"
            />
            <p className="text-[13px] text-gray-400 max-w-xs leading-relaxed">
              Arabisch strukturiert und verständlich lernen — auf Deutsch.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[13px] text-gray-500">
            <Link to="/arabisch-lernen" className="hover:text-gray-900 transition-colors">Arabisch lernen</Link>
            <Link to="/arabisch-alphabet-lernen" className="hover:text-gray-900 transition-colors">Arabisches Alphabet</Link>
            <Link to="/quran-arabisch-lernen" className="hover:text-gray-900 transition-colors">Quran-Arabisch</Link>
            <Link to="/agb" className="hover:text-gray-900 transition-colors">AGB</Link>
            <Link to="/datenschutz" className="hover:text-gray-900 transition-colors">Datenschutz</Link>
            <Link to="/impressum" className="hover:text-gray-900 transition-colors">Impressum</Link>
            <span className="text-gray-200">|</span>
            <Link to="/login" className="text-[#970000] font-medium hover:text-[#7a0000] transition-colors">
              Schülerlogin
            </Link>
          </div>

          {/* Social + Email */}
          <div className="flex items-center gap-3">
            <a
              href="mailto:info@arabicroots.de"
              aria-label="E-Mail senden"
              className="w-9 h-9 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:text-[#970000] hover:border-[#970000]/30 transition-all"
            >
              <Mail className="h-4 w-4" />
            </a>
            <a
              href="https://instagram.com/arabic.roots"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Arabicroots auf Instagram"
              className="w-9 h-9 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:text-[#970000] hover:border-[#970000]/30 transition-all"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href="https://youtube.com/@arabicroots"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Arabicroots auf YouTube"
              className="w-9 h-9 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:text-[#970000] hover:border-[#970000]/30 transition-all"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a
              href="https://tiktok.com/@arabicroots"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Arabicroots auf TikTok"
              className="w-9 h-9 rounded-lg border border-gray-200 flex items-center justify-center text-gray-500 hover:text-[#970000] hover:border-[#970000]/30 transition-all"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
              </svg>
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-gray-400">© 2026 Arabicroots. Alle Rechte vorbehalten.</p>
          <a href="mailto:info@arabicroots.de" className="text-xs text-gray-400 hover:text-gray-600 transition-colors">
            info@arabicroots.de
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
